module.exports = __webpack_public_path__ + "static/alte-haas-bold-3ea431517cbf0d42dde9290b1b3a03c0.svg";